import { useEffect } from "react";
import { useLanguage } from "../localization/LanguageContext";

function SiteSetup()
{
    const { translation } = useLanguage();

    useEffect(() =>
    {
        document.title = translation("site_title");
    })
}

export default SiteSetup;